import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { withStyles, createStyles, Grid } from "@material-ui/core";
import { ClassProps } from "./types/vm";
import FingerPrint from "./Components/FingerPrint";
import Customer from './Pages/auth/Registration';
import CustomerStats from './Pages/DailyUpdatePage';
import Reports from './Pages/Report';
import AgentList from './Pages/AgentManagement';
import TrashConsumerTable from "./Components/TrashUsers";
import Profile from './Pages/auth/Profile';
import ImageManagement from './Pages/ImageManagement'
import OldDataManagement from './Components/OldCustomerManagement'
import ConnectionDashboard from './Components/ConnectionDashboard'
import AuthenticatedRoute from './Components/auth';
import NavBar from "./Components/NavBar";
import CheckSpaceBar from "./Common/CheckSpaceBar";
import Login from "./Pages/auth/Login";
import MainDashboard from "./Pages/MainDashboard";
import UserDashBoard from "./Pages/UserDashBoard";
import Forgot from "./Pages/auth/Forgot";
import AgentDashBoard from "./Pages/AgentDashBoard";
import RejectFingerPrint from "./Components/RejectFingerPrint";
import MemberManagement from "./Pages/UserManagement";
import ConnectionPage from "./Pages/ConnectionPage";
import HomePage from "./Pages/Home";
import AgentCompleteFingerPrint from "./Components/CompleteAgentFinger";
import ProductMain from "./Pages/Ecom/ProductMain";
import SvReadyList from "./Pages/SVReadylist";



export interface RouteProps extends ClassProps { }

const Routes: React.FC<RouteProps> = ({ classes }) => {
  return (
    <Router>
      <div className="d-flex">
        <CssBaseline />
        <Switch>
          <Route path="/" exact component={Login} />
          <Route exact path="/reset" component={Forgot} />
          <Route>
            <Grid container>
              <Grid item md={2}>
                <NavBar />
              </Grid>
              <Grid item sm={12} md={10} xs={12}>
                <main className={classes.content}>
                  <CheckSpaceBar />
                  <Switch>
                    <Route exact path="/home" component={HomePage} />
                    <AuthenticatedRoute path="/dailyconsumer" exact component={CustomerStats} />
                    <AuthenticatedRoute exact path="/reports" component={Reports} />
                    <AuthenticatedRoute exact path="/agentlist" component={AgentList} />
                    <AuthenticatedRoute exact path="/trash" component={TrashConsumerTable} />
                    <AuthenticatedRoute exact path="/customerdocs" component={ImageManagement} />
                    <AuthenticatedRoute exact path="/delivery" component={MainDashboard} />
                    <AuthenticatedRoute exact path="/dash" component={UserDashBoard} />
                    <AuthenticatedRoute exact path="/customer" component={Customer} />
                    <AuthenticatedRoute exact path="/reset" component={Forgot} />
                    <AuthenticatedRoute exact path="/profile" component={Profile} />
                    <AuthenticatedRoute exact path="/connection" component={ConnectionPage} />
                    <AuthenticatedRoute exact path="/olddatamanagement" component={OldDataManagement} />
                    <AuthenticatedRoute exact path="/connection" component={ConnectionDashboard} />
                    <AuthenticatedRoute exact path="/agentdashboard" component={AgentDashBoard} />
                    <AuthenticatedRoute exact path="/fingerprint" component={FingerPrint} />
                    <AuthenticatedRoute exact path="/rejectfingerPrint" component={RejectFingerPrint} />
                    <AuthenticatedRoute exact path="/completefingerPrint" component={AgentCompleteFingerPrint} />
                    <AuthenticatedRoute exact path="/member" component={MemberManagement} />
                    <AuthenticatedRoute exact path="/svreadylist" component={SvReadyList} />
                    <AuthenticatedRoute exact path="/products" component={ProductMain} />
                  </Switch>
                </main>
              </Grid>
            </Grid>
          </Route>
        </Switch>
      </div>
    </Router>
  );
};

const styles = () =>
  createStyles({
    appBarSpacer: {
      height: 48
    },
    content: {
      flexGrow: 1,
      height: "100vh",
      overflow: "auto",
      padding: 16,
      backgroundColor: "#fbfbfb"
    }
  });

export default withStyles(styles)(Routes);
